// Utilitários da especificação (o "carrinho" do arquiteto): unidades, quantidades,
// agrupamento por departamento e redução de imagem antes do upload.

// Unidade do ERP → como o arquiteto lê
const UNID = { M2: 'm²', M: 'm', ML: 'm', UN: 'un', PC: 'pç', CX: 'cx', KG: 'kg', L: 'L', LT: 'L', SC: 'sc', GL: 'gl', JG: 'jg', CJ: 'cj', RL: 'rl', BD: 'bd' };
export const fmtUnid = (u) => UNID[String(u || '').toUpperCase()] || String(u || 'un').toLowerCase();

// Unidades que aceitam fração (15,5 m²); o resto é inteiro (2 un)
const DECIMAL = new Set(['M2', 'M', 'ML', 'KG', 'L', 'LT']);
export const aceitaDecimal = (u) => DECIMAL.has(String(u || '').toUpperCase());

export const fmtNum = (n) => Number(n || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
export const fmtQtd = (q, u) => `${fmtNum(q)} ${fmtUnid(u)}`;
// "15,5" / "15.5" → 15.5 (NaN se inválido)
export const lerNum = (t) => {
  const s = String(t ?? '').trim();
  // Com vírgula = formato BR (1.234,5); sem vírgula, o ponto é decimal (teclado do celular)
  return Number(s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s);
};

// Unidades oferecidas no item fora do catálogo
export const UNIDADES_LIVRE = [
  ['UN', 'un — unidade'], ['M2', 'm² — metro quadrado'], ['M', 'm — metro linear'], ['PC', 'pç — peça'],
  ['CX', 'cx — caixa'], ['JG', 'jg — jogo'], ['CJ', 'cj — conjunto'], ['KG', 'kg — quilo'], ['L', 'L — litro'],
];

// Ambientes mais comuns num projeto (os que a pessoa já usou aparecem antes)
export const AMBIENTES_PADRAO = [
  'Banheiro social', 'Banheiro suíte', 'Lavabo', 'Cozinha', 'Área gourmet', 'Área de serviço',
  'Sala', 'Quartos', 'Varanda', 'Área externa', 'Garagem', 'Piscina',
];

// Itens agrupados por departamento, na ordem do catálogo (igual ao PDF quantitativo)
export function agruparPorDepartamento(itens) {
  const mapa = new Map();
  for (const i of itens || []) {
    const k = i.departamento || 'Outros';
    if (!mapa.has(k)) mapa.set(k, { nome: k, ordem: i.ordemDep ?? 999, itens: [] });
    mapa.get(k).itens.push(i);
  }
  return [...mapa.values()].sort((a, b) => a.ordem - b.ordem || a.nome.localeCompare(b.nome, 'pt-BR'));
}

export const dataCurta = (d) => {
  if (!d) return '—';
  const x = new Date(d);
  return Number.isNaN(x.getTime()) ? '—' : x.toLocaleDateString('pt-BR');
};

// Reduz a foto no navegador antes de mandar (celular tira foto de 4-8 MB).
// PNG continua PNG (logo com fundo transparente); o resto vira JPEG.
export function reduzirImagem(file, { max = 1000, qualidade = 0.82 } = {}) {
  return new Promise((resolve, reject) => {
    if (!file || !/^image\//.test(file.type)) { reject(new Error('Escolha uma imagem (JPG, PNG ou WEBP)')); return; }
    const leitor = new FileReader();
    leitor.onerror = () => reject(new Error('Não foi possível ler a imagem'));
    leitor.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Imagem inválida'));
      img.onload = () => {
        const escala = Math.min(1, max / Math.max(img.width, img.height));
        const w = Math.round(img.width * escala), h = Math.round(img.height * escala);
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        const png = file.type === 'image/png';
        if (!png) { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); }
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL(png ? 'image/png' : 'image/jpeg', qualidade));
      };
      img.src = leitor.result;
    };
    leitor.readAsDataURL(file);
  });
}

// PDF que o arquiteto já fez no programa dele (quantitativo pronto)
export const MAX_PDF_MB = 20;
export const fmtTamanho = (bytes) => {
  const n = Number(bytes || 0);
  return n >= 1024 * 1024 ? `${(n / 1024 / 1024).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} MB` : `${Math.max(1, Math.round(n / 1024))} KB`;
};
export const validarPdf = (file) => {
  if (!file) return 'Escolha o arquivo PDF';
  const ehPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
  if (!ehPdf) return 'O arquivo precisa ser um PDF';
  if (file.size > MAX_PDF_MB * 1024 * 1024) return `O PDF pode ter no máximo ${MAX_PDF_MB} MB`;
  return null;
};

// Situação da especificação na lista/detalhe (depende de como ela foi montada)
export const situacaoDe = (e) => {
  if (e?.origem === 'pdf') {
    return (e.tem_pdf || e.pdf)
      ? { rotulo: 'PDF enviado', classe: 'pronta', icone: 'bi-file-earmark-check' }
      : { rotulo: 'Aguardando PDF', classe: 'montagem', icone: 'bi-hourglass-split' };
  }
  return e?.status === 'finalizada'
    ? { rotulo: 'PDF gerado', classe: 'pronta', icone: 'bi-file-earmark-check' }
    : { rotulo: 'Em montagem', classe: 'montagem', icone: 'bi-pencil-square' };
};
